import React, { useState } from "react";

function SunnyvaleShowHide() {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <div className="junk-santa">
        <h3>Serving Sunnyvale, CA, and Surrounding Areas</h3>
        <div className="sliderline-svg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="4"
            viewBox="0 0 64 4"
            fill="none"
          >
            <path
              d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
              fill="#60BDFF"
            ></path>
          </svg>
        </div>
      </div>

      <div className="junk-santa-desc">
        <p>
          We proudly serve Sunnyvale, Mountain View, Palo Alto, Los Gatos, Menlo
          Park, and other cities within Santa Clara County. Whether you need
          junk removal for your home, commercial property, or construction site,
          we’re here to provide fast, affordable, and professional service.
        </p>
      </div>

      {isExpanded && (
        <div>
          <div className="pt-0 junk-santa-desc milpitas-list">
            <h3>Contact Junk Droid for Junk Removal in Sunnyvale, CA</h3>
            <div className="sliderline-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="4"
                viewBox="0 0 64 4"
                fill="none"
              >
                <path
                  d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                  fill="#60BDFF"
                ></path>
              </svg>
            </div>
            <div className="junk-santa-desc pt-0">
              <p>
                Ready to clear out your unwanted junk? Call Junk Droid for a
                free estimate today! Whether it’s old appliances, furniture
                disposal, or construction debris removal, we offer reliable and
                affordable junk removal services in Sunnyvale, CA. Get in touch
                with us now to book your same-day junk removal.
              </p>
            </div>
          </div>
        </div>
      )}

      <button className="btn btn-read" onClick={toggleText}>
        {isExpanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
}

export default SunnyvaleShowHide;
